import { Loading } from "../common/Loading";

export function ScannerFinder() {
  return (
    <>
      <div
        className={
          "top-0 left-0 w-full h-full flex justify-center items-center absolute -z-10"
        }
      >
        <svg
          viewBox={"0 0 100 100"}
          style={{
            top: 0,
            left: 0,
            position: "absolute",
            background: "rgba(0,0,0,0.1)",
            width: "100%",
            height: "100%",
          }}
        ></svg>
        <Loading className={"text-primary loading-lg"} />
      </div>
      <svg
        viewBox={"0 0 100 100"}
        style={{
          top: 0,
          left: 0,
          zIndex: 1,
          position: "absolute",
          width: "100%",
          height: "100%",
        }}
      >
        <path
          fill={"none"}
          d={"M25,10 L10,10 L10,25"}
          stroke={"oklch(var(--pc))"}
          strokeWidth={1}
          strokeLinecap={"round"}
        />
        <path
          fill={"none"}
          d={"M10,75 L10,90 L25,90"}
          stroke={"oklch(var(--pc))"}
          strokeWidth={1}
          strokeLinecap={"round"}
        />
        <path
          fill={"none"}
          d={"M75,90 L90,90 L90,75"}
          stroke={"oklch(var(--pc))"}
          strokeWidth={1}
          strokeLinecap={"round"}
        />
        <path
          fill={"none"}
          d={"M90,25 L90,10 L75,10"}
          stroke={"oklch(var(--pc))"}
          strokeWidth={1}
          strokeLinecap={"round"}
        />
      </svg>
    </>
  );
}
